const Categories = [
  {
    category: "Entrantes y Aditivos",
    image: "/images/CategoryImages/category-entrantes.png",
  },
  {
    category: "Desayunos",
    image: "/images/CategoryImages/category-desayunos.png",
  },
  {
    category: "Pizzas y Espaguetis",
    image: "/images/CategoryImages/category-pizzas.png",
  },
  {
    category: "Hamburguesas y Sandwish",
    image: "/images/CategoryImages/category-hamburguesas.png",
  },
  {
    category: "Tacos",
    image: "/images/CategoryImages/category-tacos.png",
  },
  {
    category: "Bebidas",
    image: "/images/CategoryImages/category-bebidas.png",
  },
  {
    category: "Cocteles",
    image: "/images/CategoryImages/category-cocteles.png",
  },
  {
    category: "Postres",
    image: "/images/CategoryImages/category-postres.png",
  },
  {
    category: "Infusiones-Cafe-Te",
    image: "/images/CategoryImages/category-infusiones.png",
  },
];
export default Categories;
